export default __webpack_public_path__ + "static/media/eatnwatchlogo.3dfa4650.png";